const authentication = require('../../../react-azure-adb2c2').default;




export function detail(values: any) {

    // const url = `http://localhost:5000/v1/web/video/call/reservations/details/` + values;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/web/video/call/reservations/details/` + values;

    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
        method: 'get',
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

export function update(values: any) {

    console.log(values)
    const token = authentication.getAccessToken();

    // const url = `http://localhost:5000/v1/web/video/call/reservations/update`;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/web/video/call/reservations/update`;

    // alert(url)
    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}

export function insert(values: any) {

    console.log(values)
    const token = authentication.getAccessToken();

    // const url = `http://localhost:5000/v1/web/video/call/reservations/insert`;
    const url = process.env.REACT_APP_API_CRM_URL + `/v1/web/video/call/reservations/insert`;

    // alert(url)
    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}